/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 老项目域名地址
 * khglUrl: 客户管理域名地址
 * dicUrl : 字典服务器地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * welUrl :默认欢迎页
 *
 */

let baseUrl = ''
//at.alicdn.com/t/c/font_3418556_2z1bm0eaj7u.css
// const iconfontVersion = ['3418556_2z1bm0eaj7u']
// const iconfontUrl = `//at.alicdn.com/t/c/font_$key.css`
const codeUrl = `/admin/code`
if (process.env.NODE_ENV == 'development') {
  baseUrl = `http://192.168.1.39:9999/`;
} else if (process.env.NODE_ENV == 'production') {
  baseUrl = `http://192.168.1.39:9999`;
}

export {
  baseUrl,
  // iconfontUrl,
  // iconfontVersion,
  codeUrl
}



// WEBPACK FOOTER //
// ./src/config/env.js